import { FaCreditCard } from "react-icons/fa6";
import { BsTrashFill } from "react-icons/bs";
import { FaCheck } from "react-icons/fa6";
import styles from "./SelectBankAccount.module.css";
import Swal from "sweetalert2";
import { useMutation } from "@tanstack/react-query";
import { putRequestByAuth } from "../../../../../function/helper";

function SelectBankAccount({ onSelect, isSelected, item, onDelete }) {
  const { mutate } = useMutation({
    mutationKey: ["delete-bank-account"],
    mutationFn: id =>
      putRequestByAuth("/bank-account/v1/delete", { id }).then(res => {
        if (res && res.status === 200) {
          Swal.fire({
            icon: "success",
            title: res.data.message,
            confirmButtonText: "متوجه شدم",
          }).then(onDelete);
          return;
        }

        Swal.fire({
          icon: "error",
          title: res.data.message,
          confirmButtonText: "متوجه شدم",
          confirmButtonColor: "red",
        });
      }),
  });

  const handleDeleteBankAccout = () => {
    Swal.fire({
      icon: "error",
      title: "آیا از حذف حساب بانکی مطمئنید؟",
      confirmButtonColor: "red",
      confirmButtonText: "بله",
      cancelButtonColor: "gray",
      cancelButtonText: "خیر",
      showCancelButton: true,
    }).then(res => {
      if (res.isConfirmed) {
        mutate(item.id);
      }
    });
  };

  return (
    <article
      className={`buttonUi w-100 d-flex py-2 px-3 my-3 column-gap-3 ${
        styles.box
      } ${isSelected ? styles.selected : ""}`}
      onClick={onSelect}
      type="button"
    >
      <div className="d-flex align-items-center">
        <FaCreditCard size="24" color="#11ae81" />
      </div>
      <div className="d-flex flex-wrap align-items-center w-100 column-gap-4 row-gap-2">
        <p>
          <span>نام: </span>
          <strong>{item.name}</strong>
        </p>

        <p>
          <span>نام خانوادگی: </span>
          <strong>{item.lName}</strong>
        </p>

        <p>
          <span>نام بانک: </span>
          <strong>{item.bankName}</strong>
        </p>

        <div className="w-100 d-flex flex-wrap justify-content-between">
          <p>
            <span>شبا: </span>
            <strong>{item.shabaNumber}</strong>
          </p>

          <button
            className="buttonUi me-auto"
            type="button"
            onClick={handleDeleteBankAccout}
          >
            <BsTrashFill color="red" size="16" />
          </button>
        </div>
      </div>

      {isSelected && (
        <div className={styles.check}>
          <FaCheck />
        </div>
      )}
    </article>
  );
}

export default SelectBankAccount;
